module.exports = __webpack_public_path__ + "img/usdt_transfer3.be1a0579.png";